module.exports = __webpack_public_path__ + "img/2-detail.8a143cca.jpg";